import { Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function ResumeSignupNotice({ promo }: { promo?: string | null }) {
	const query = promo ? `?${new URLSearchParams({ promo })}` : "";
	return (
		<div role="status" className="my-20 flex w-full flex-col gap-16">
			<Typography>
				Looks like you already started an account with this email, but no pet is active on it yet. Sign in to finish.
			</Typography>
			<Button component={Link} to={`/sign-in${query}`} variant="contained" color="secondary" fullWidth>
				Sign in
			</Button>
		</div>
	);
}
